define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var BulkEditProductModel = /** @class */ (function () {
        function BulkEditProductModel(data) {
            this.CategoryId = ko.observable();
            this.ProductType = ko.observable();
            this.Tax1Id = ko.observable();
            this.Tax2Id = ko.observable();
            this.BulkEditCategory = ko.observable();
            this.BulkEditProductType = ko.observable();
            this.BulkEditTax1 = ko.observable();
            this.BulkEditTax2 = ko.observable();
            this.Products = ko.observableArray();
            this.ProductIds = ko.observableArray();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, BulkEditProductModel.Mapping, self);
            }
        }
        BulkEditProductModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new BulkEditProductModel(options.data);
            }
        };
        return BulkEditProductModel;
    }());
    return BulkEditProductModel;
});
//# sourceMappingURL=BulkEditProductModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/BulkEditProductModel.js
// module id = 295
// module chunks = 2